// App download configuration
export const APP_DOWNLOAD = {
  enabled: true,
  playStoreUrl: 'https://play.google.com/store/apps/details?id=com.rasikboy.studyhelper&pcampaignid=web_share',
  qrImageUrl: '/questguru-android-download-qr.png',
  // QR image size
  qrSize: 300,
};

export default APP_DOWNLOAD;
